<template>
  <v-container @click="showEdits = true" pa-0 fluid>
    <v-layout grid-list-xs align-baseline>
      <v-flex v-if="serviceGrouping" sm3>
        <dates-range-picker
          v-if="showEdits"
          :gtDateFromString="rateItem.dateFrom"
          :gtDateToString="rateItem.dateTo"
          @onRangeSelected="onDatesRangeSelected($event)"
        ></dates-range-picker>
        <v-layout v-else row>
          <v-flex sm6>
            <v-layout column>
              <label class="grey--text text--darken-1 caption">Date From</label>
              <span>{{ rateItem.dateFrom | formatDate }}</span>
            </v-layout>
          </v-flex>
          <v-flex sm6>
            <v-layout column>
              <label class="grey--text text--darken-1 caption">Date To</label>
              <span>{{ rateItem.dateTo | formatDate }}</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="!serviceGrouping" sm2>
        <v-text-field
          v-if="showEdits"
          label="Service"
          :value="item.service.name"
          readonly
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Service</label>
          <span>{{ item.service.name }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-select
          v-if="showEdits"
          :items="rateTypes"
          v-model="rateItem.rateTypeCode"
          label="Rate Type"
          item-text="name"
          item-value="code"
          @change="onChange()"
        >
          <template slot="selection" slot-scope="data">{{
            data.item.code
          }}</template>
        </v-select>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Rate Type</label>
          <span>{{ rateItem.rateTypeCode }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Cost"
          v-model.number="rateItem.adultBuy1"
          type="number"
          min="0"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Cost</label>
          <span>{{ rateItem.adultBuy1 }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Sell"
          v-model.number="rateItem.adultSell1"
          type="number"
          min="0"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Sell</label>
          <span>{{ rateItem.adultSell1 }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <currency-list-select
          v-if="showEdits"
          custom-label="Currency"
          :currencyCode="rateItem.currencyCode"
          v-model="rateItem.currencyCode"
          :showCodeAsName="true"
          @input="onChange"
        ></currency-list-select>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Currency</label>
          <span>{{ rateItem.currencyCode }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Markup"
          v-model.number="rateItem.markup"
          type="number"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Markup</label>
          <span>{{ rateItem.markup }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Min Stay"
          v-model.number="rateItem.minStay"
          type="number"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Min Stay</label>
          <span>{{ rateItem.minStay }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Max Stay"
          v-model.number="rateItem.maxStay"
          type="number"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Max Stay</label>
          <span>{{ rateItem.maxStay }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          v-if="showEdits"
          label="Rate Plan"
          v-model="rateItem.ratePlan"
          @change="onChange()"
        ></v-text-field>
        <v-layout v-else column>
          <label class="grey--text text--darken-1 caption">Rate Plan</label>
          <span>{{ rateItem.ratePlan }}</span>
        </v-layout>
      </v-flex>
      <v-flex sm1>
        <default-list-actions
          v-if="showEdits"
          :item="rateItem"
          :hide-view="true"
          item-name="supplier rate"
          @editItem="$emit('editItem', rateItem)"
          @deleteItem="$emit('deleteItem', rateItem)"
        ></default-list-actions>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SERVICE_PRICE_UPDATE_MUTATION } from "../../../../../constants/graphql";
import DatesRangePicker from "../../../shared/DatesRangePicker";
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import DefaultListActions from "../../../shared/DefaultListActions";

export default {
  name: "SupplierRatesEditVlistViewItem",
  components: {
    DatesRangePicker,
    CurrencyListSelect,
    DefaultListActions,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    serviceGrouping: {
      type: Boolean,
      default: false,
    },
    rateTypes: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      showEdits: false,
      debug: false,
      rateItem: {},
    };
  },
  methods: {
    onDatesRangeSelected(data) {
      this.rateItem.dateTo = data.dateTo;
      this.rateItem.dateFrom = data.dateFrom;
      this.onChange();
    },
    onChange() {
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_UPDATE_MUTATION,
          variables: {
            ...this.rateItem,
            adultBuy1: parseFloat(this.rateItem.adultBuy1),
            adultSell1: parseFloat(this.rateItem.adultSell1),
          },
        })
        .then((data) => {
          this.$emit("save");
        });
    },
    roundPricesDecimals() {
      this.rateItem.adultBuy1 = parseFloat(this.rateItem.adultBuy1).toFixed(2);
      this.rateItem.adultSell1 = parseFloat(this.rateItem.adultSell1).toFixed(
        2
      );
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(data) {
        this.rateItem = { ...data };
        this.roundPricesDecimals();
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/SupplierRatesEditVlistViewItem.vue